import { createContext } from 'react';

export const SectionContext = createContext({
  sections: [],
  fetchAllSections: () => {},
});
